import React, {ReactNode} from 'react';
import {inject, observer} from 'mobx-react';
import {PokerStore} from 'app/store/PokerStore';
import PokerContainer from 'app/components/poker/PokerContainer';

interface Props {
    pokerStore?: PokerStore
}

interface States {
    lastTouchId: number
}

@inject('pokerStore')
@observer
export default class PokerTableList extends React.Component<Props, States> {
    constructor(props: Props) {
        super(props);

        this.state = {
            lastTouchId: 0
        };
    }

    handleActivate = (id: number): void => {
        this.setState({lastTouchId: id});
    };

    render(): ReactNode {
        const {pokerStore} = this.props;

        return <>
            {Array.from(pokerStore.currentTables.values()).map(t => <PokerContainer
                key={t.currentTable.id}
                table={t}
                onActivate={this.handleActivate}
                lastDraggedElement={this.state.lastTouchId === t.currentTable.id}
            />)}
        </>;
    }
}
